import { createMultiStyleConfigHelpers as t } from "@chakra-ui/react";
const { defineMultiStyleConfig: e, definePartsStyle: n } = t([
  "container",
  "chatIcon",
  "defaultContent"
]), a = e({
  baseStyle: {
    container: {
      bg: "gray.50",
      p: "4",
      h: { base: "fit-content", md: "112px" },
      minH: "72px",
      position: "relative"
    },
    defaultContent: {
      flexDir: { base: "column", md: "row" },
      gap: "0px 16px",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      mx: { base: "0", md: "80px" },
      "a, p": {
        textStyle: "bodySmall",
        textDecoration: "none"
      }
    },
    chatIcon: {
      borderRadius: "full",
      position: "absolute",
      right: { base: "16px", md: "40px" },
      top: { base: "16px", md: "32px" }
    }
  },
  variants: {
    stickToBottom: {
      container: {
        bottom: "0",
        left: "0",
        position: "fixed",
        zIndex: "1000",
        width: "100%"
      }
    }
  }
});
export {
  a as default,
  a as footerTheme
};
